export const NATIVE_COIN_ADDRESS = "NATIVE_COIN_ADDRESS";
